import React, { useEffect } from 'react';
import { Button, Spin } from 'antd';
 
interface SuspenseFallbackProps {
 
}
 
export const SuspenseFallback: React.FunctionComponent<SuspenseFallbackProps> = () => {
 
    const [spinning, setSpinning] = React.useState<boolean>(false);
    const showLoader = () => {
        setSpinning(true);
        // 8000 milliseconds = 8 seconds
    };
    
    useEffect(() => {
        showLoader()
    }, []);
    return (
        <Spin spinning={spinning}  fullscreen />
    );
}